import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase/IconBase'

const CopyToClipboard = ({
  color = 'icon.original',
  fill = 'transparent',
  strokeWidth = '1.5',
  ...props
}) => (
  <IconBase viewBox='0 0 14 14' {...props}>
    <Rect
      width='9.33062'
      height='9.33423'
      rx='2'
      transform='matrix(-1 0 0 1 10.3281 3.66406)'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <Path
      d='
        M10.3341 10.3342
        H11.6671
        C12.4032 10.3342 13 9.73722 13 9.00077
        V2.33346
        C13 1.59701 12.4032 1 11.6671 1
        H5.00232
        C4.26616 1 3.66938 1.59701 3.66938 2.33346
        V3.66692
      '
      stroke={color}
      fill='transparent'
      strokeWidth={strokeWidth}
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </IconBase>
)

CopyToClipboard.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default CopyToClipboard
